import iconOne from "@data/images/icons/linea-basic-credit.svg";
import iconTwo from "@data/images/icons/linea-basic-human-talent.svg";
import iconThree from "@data/images/icons/linea-basic-pqr.svg";
import iconFour from "@data/images/icons/linea-basic-administrative.svg";
import iconFive from "@data/images/icons/linea-basic-crm.svg";
import iconSix from "@data/images/icons/linea-basic-financial.svg";
import iconSeven from "@data/images/icons/linea-basic-customers.svg";
import iconEight from "@data/images/icons/linea-basic-collections.svg";
import iconNine from "@data/images/icons/linea-basic-shopping.svg"

export const data = [
	{
		id: "box-icon-1-1",
		title: "Crédito",
		desc: `Mantiz le ofrece todas las funcionalidades para implementar y controlar sus procesos de Originación, legalización y desembolso de crédito. No importa si su entidad maneja un proceso de crédito tradicional o si desea implementar un modelo de crédito instantáneo, Mantiz le permitirá definir cada aspecto de Manera personalizada; modele y conecte su proceso con todos sus sistemas, consulte y procese de forma automática toda la información de sus clientes tomando decisiones ajustadas 100% a sus políticas.
		 Mantiz le permite manejar sus procesos de crédito en cualquier segmento, ya sea banca personal, pyme, empresarial, corporativa, microcrédito o cualquier tipo de financiera, podrá crear un flujo a la medida de sus necesidades. Cree e implemente sus modelos de scoring o conecte uno externo, monte sus modelos de pricing, genere e imprima toda la documentación o utilice nuestra capacidad de firma electrónica para digitalizar su operación, distribuya sus operaciones de manera eficiente y maximice su capacidad operativa y mucho más.
		 Con Mantiz puede manejar el 100% de sus políticas sobre el sistema implementar cambios en su proceso en cuestión de semanas para mantenerlo actualizado al ritmo que cambia su negocio, ofrecemos toda la trazabilidad y seguridad que su entidad necesita y más de 20 años de experiencia en implementación de procesos en el sector para Colombia y América Latina`,
		path: "/",
		icon: iconOne
	},
	{
		id: "box-icon-1-2",
		title: "Talento Humano",
		desc: `Automatizar los procesos de selección, vinculación, seguimiento, evaluación y registro de novedades de su personal es muy simple con Mantiz, modele todos y cada uno de esos procesos que lleva manualmente o por correo electrónico, permitiendo unificar la información y documentación sobre una sola herramienta.
		Lleve el control de los procesos de vacaciones, licencias, permisos, incapacidades, y todo lo que requiere para tener el conocimiento completo sobre las novedades de su recurso humano. Ofrezca a sus empleados las herramientas para que realicen autogestión de aquellas solicitudes que no requieren de su intervención y tenga total control y trazabilidad de sus procesos y tiempos de respuesta.`,
		path: "/",
		icon: iconTwo
	},
	{
		id: "box-icon-1-3",
		title: "PQR",
		desc: `Mantiz le permite personalizar su proceso de gestión de PQR, centralice la gestión de solicitudes recibidas por diferentes canales con total control del estado de estas en cualquier momento, direccione correctamente sus transacciones, asigne y controle de manera automática los tiempos de respuesta, notifique los avances o demoras en el proceso y eleve sus niveles de cumplimiento al máximo.
		La gestión de PQR con Mantiz le permite personalizar el proceso de acuerdo con las necesidades de su negocio. No se adapte a la herramienta, deje que la herramienta se adapte a usted y lleve su operación a donde siempre quiso.`,
		path: "/",
		icon: iconThree
	},
	{
		id: "box-icon-1-4",
		title: "Administrativos",
		desc: `Modele e implemente rápidamente todos esos procesos operativos que maneja a través de correo electrónico o sobre Excel, automatice notificaciones, tareas y validaciones, programe tareas o alertas en el tiempo y centralice en un solo repositorio la información de todos sus procesos de Gestión Administrativa.
		 Con Mantiz tener una plataforma que permita tener trazabilidad y control de cada operación en su Flujo de trabajo es posible `,
		path: "/",
		icon: iconFour
	},
	{
		id: "box-icon-1-5",
		title: "CRM",
		desc: `Amplie su capacidad de administrar la gestión de relación con sus clientes, integre su CRM plenamente a sus procesos a través de Mantiz o cree su propio esquema de gestión de relacionamiento y lleve la gestión a un nuevo nivel.
				Mantiz le ayuda a integrar la valiosa información de CRM a sus procesos de negocio para maximizar su capacidad de satisfacer al cliente y a retroalimentar su CRM con todo lo que ocurra en relación con sus clientes.`,
		path: "/",
		icon: iconFive
	},
	{
		id: "box-icon-1-6",
		title: "Financieros",
		desc: `¿Problemas con el control de pagos o recaudos?, ¿requiere recopilar información de la operación de negocio para sus procesos de facturación y no la tiene disponible? Con Mantiz puede implementar todo lo que requiere para que su gestión financiera este bajo control con total trazabilidad y seguridad.`,
		path: "/",
		icon: iconSix
	},
	// {
	// 	id: "box-icon-1-7",
	// 	title: "Clientes CRM",
	// 	desc: "",
	// 	path: "/",
	// 	icon: iconSeven
	// },
	// {
	// 	id: "box-icon-1-8",
	// 	title: "Cobranzas",
	// 	desc: "",
	// 	path: "/",
	// 	icon: iconEight
	// },
	{
		id: "box-icon-1-9",
		title: "Compras",
		desc: `Lleve el control de la vinculación, evaluación y actualización de sus proveedores, modele su proceso de compras y contratación de punta a punta. Controle presupuestos e implemente de manera personalizada todas sus políticas y requerimientos, mantenga el control documental y rastreo de sus operaciones de compra y contratación en un solo lugar.`,
		path: "/",
		icon: iconNine
	}
]